export default "__VITE_ASSET__05cc2173__"